import React from 'react';
import cx from 'classnames';

import ContextualContent from '../../atoms/ContextualContent';
import Select from '../../atoms/Select';
import Text from '../../atoms/Text';

import styles from './SelectField.module.scss';
import usePresenter from './SelectField.presenter';
import getProps from './SelectField.props';
import { SelectFieldCombinedProps } from './types';
import TextInput from '../../atoms/TextInput';


const SelectField: React.FC<SelectFieldCombinedProps> = (props) => {
  const {
    state,
    className,
    classes,
    text,
    select,
    contextualContent,
    textInput,
  } = usePresenter(props);

  const variantName = `${state}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`selectField${variantName}`];

  let componentView;

  switch (variantName) {
    // MANUAL OVERRIDE
    case 'NoOptions': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <TextInput
            className={cx(styles.textInput, classes?.textInput)}
            {...internalProps.textInput}
            {...textInput}/>
        </div>
      );
      break;
    }
    case 'Default': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <Select
            className={cx(styles.select, classes?.select)}
            {...internalProps.select}
            {...select}/>
        </div>
      );
      break;
    }
    case 'Error': {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
          <Select
            className={cx(styles.select, classes?.select)}
            {...internalProps.select}
            {...select}/>
          <ContextualContent
            className={cx(styles.contextualContent, classes?.contextualContent)}
            {...internalProps.contextualContent}
            {...contextualContent}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default SelectField;

